import Vue from "vue";
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";
import "firebase/messaging";
import { rtdbPlugin } from "vuefire";
Vue.use(rtdbPlugin);

import * as firebaseui from "firebaseui";
import * as firebaseConfig from "firebase/app";
import "firebaseui/dist/firebaseui.css";

export const DB_ROOT = "shop-app";

// Initialize Firebase
const config = {
  apiKey: "AIzaSyDZt98CIUYUBPeW32wvtA5hWOFlSLp03C0",
  authDomain: "ptw.firebaseapp.com",
  databaseURL: "https://ptw.firebaseio.com",
  projectId: "firebase-ptw",
  storageBucket: "firebase-ptw.appspot.com",
  messagingSenderId: "281865054216",
  appId: "1:281865054216:web:e2d79f491c1cc7d1"
};

const uiConfig = {
  signInFlow: "popup",
  signInOptions: [
    // Leave the lines as is for the providers you want to offer your users.
    firebaseConfig.auth.GithubAuthProvider.PROVIDER_ID,
    firebaseConfig.auth.FacebookAuthProvider.PROVIDER_ID,
    firebaseConfig.auth.GoogleAuthProvider.PROVIDER_ID,
    firebaseConfig.auth.EmailAuthProvider.PROVIDER_ID
  ],
  callbacks: {
    // Called when the user has been successfully signed in.
    signInSuccess: function() {
      // Do not redirect.
      return false;
    }
  },
  // Terms of service url.
  tosUrl: "https://ptw.fritscher.ch"
};

const firebaseApp = firebase.initializeApp(config);
export const db = firebaseApp.database().ref(DB_ROOT);
export const auth = firebaseApp.auth();
export const storage = firebaseApp.storage();

// Initialize the FirebaseUI Widget using Firebase.
export const ui = new firebaseui.auth.AuthUI(auth);

export function startLoginUI() {
  ui.start("#firebaseui-auth-container", uiConfig);
}

export const messaging = firebase.messaging();

// TODO: could be more customizable to enable/disable
// https://github.com/firebase/functions-samples/blob/master/fcm-notifications/public/main.js
function sendTokenToServer(token) {
  if (auth.currentUser && auth.currentUser.uid) {
    db.child("users")
      .child(auth.currentUser.uid)
      .child("tokens")
      .child(token)
      .set(true);
  }
}

navigator.serviceWorker
  .register("static/firebase-messaging-sw.js")
  .then(registration => {
    messaging.useServiceWorker(registration);
    messaging
      .requestPermission()
      .then(() => {
        // Notification permission granted.
        // Get Instance ID token. Initially this makes a network call, once retrieved
        // subsequent calls to getToken will return from cache.
        auth.onAuthStateChanged(user => {
          if (!user) {
            return;
          }
          messaging
            .getToken()
            .then(function(currentToken) {
              if (currentToken) {
                sendTokenToServer(currentToken);
                // console.log('currentToken', currentToken);
              } else {
                // Show permission request.
                console.log(
                  "No Instance ID token available. Request permission to generate one."
                );
                // Show permission UI.
              }
            })
            .catch(function(err) {
              console.log("An error occurred while retrieving token. ", err);
            });

          // Callback fired if Instance ID token is updated.
          messaging.onTokenRefresh(function() {
            messaging
              .getToken()
              .then(function(refreshedToken) {
                // Send Instance ID token to app server.
                sendTokenToServer(refreshedToken);
              })
              .catch(function(err) {
                console.log("Unable to retrieve refreshed token ", err);
              });
          });
        });
        /* sample getting message when app in front
                messaging.onMessage(function (payload) {
                    console.log('Message received. ', payload);
                    // ...
                });
                */
      })
      .catch(err => {
        console.log("Unable to get permission to notify.", err);
      });
  });
